import { useQuery } from 'react-query';
import { getInvoiceDataUseCases } from '@subscriptions/composition';
import type { InvoiceDataViewDto } from '@subscriptions/application/dtos';

/**
 * Hook for listing all invoice data of the current organization.
 *
 * @param options - Optional query configuration
 * @returns Query result with invoice data list
 */
export const useInvoiceData = (options?: { enabled?: boolean }) => {
  const { listInvoiceData } = getInvoiceDataUseCases();

  return useQuery<InvoiceDataViewDto[], Error>(
    ['subscriptions', 'invoice-data', 'list'],
    () => listInvoiceData.execute(),
    {
      enabled: options?.enabled ?? true,
      refetchOnWindowFocus: false,
    },
  );
};
